export default __webpack_public_path__ + "static/media/Gallery-22.c146a64f.jpeg";